import React from 'react';
import Modal from '../Modal/Modal';
import Button from '../Button/Button';
import styles from './ConfirmDialog.module.css';

const ConfirmDialog = ({
    show,
    onClose,
    onConfirm,
    title = 'Подтверждение',
    message,
    confirmLabel = 'Подтвердить',
    cancelLabel = 'Отмена',
    variant = 'default',
    loading = false,
    destructive = false
}) => {
    const handleConfirm = () => {
        if (!loading && onConfirm) {
            onConfirm();
        }
    };

    const getConfirmVariant = () => {
        if (destructive) {
            return 'danger';
        }
        return variant === 'primary' ? 'primary' : 'primary';
    };

    return (
        <Modal
            show={show}
            onClose={onClose}
            title={title}
            closeOnOverlayClick={!loading}
            closeOnEscape={!loading}
            footer={
                <>
                    <Button
                        variant="secondary"
                        onClick={onClose}
                        disabled={loading}
                    >
                        {cancelLabel}
                    </Button>
                    <Button
                        variant={getConfirmVariant()}
                        onClick={handleConfirm}
                        loading={loading}
                        disabled={loading}
                    >
                        {confirmLabel}
                    </Button>
                </>
            }
        >
            <div className={styles.content}>
                {destructive && (
                    <div className={styles.warningIcon}>
                        <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                            <circle cx="24" cy="24" r="22" fill="var(--color-danger-light)" />
                            <path
                                d="M24 12V24M24 32V24M24 24H12M24 24H36"
                                stroke="var(--color-danger)"
                                strokeWidth="3"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </div>
                )}
                <p className={styles.message}>{message}</p>
            </div>
        </Modal>
    );
};

export default ConfirmDialog;
